import { REQUIRED_ACTIONS_INITIAL_VALUES } from '@/assets/js/config/client'
import { STOREMODULE_ENDPOINTMODULE_MAP } from '@/assets/js/config/server'

import http from '@/$plugins/http'
import Vue from 'vue'

import base from './index'

export default {
  state: {
    requiredActions: []
  },
  getters: {
    getRequiredActions: state => state.requiredActions,
    getRequiredAction: state => actionId => state.requiredActions.find(a => a.id === actionId)
  },
  mutations: {
    setRequiredActions (state, actions = []) {
      state.requiredActions = actions
    },
    setRequiredAction (state, action = {}) {
      const updateIndex = state.requiredActions.findIndex(a => a.id === action.id)
      const newIndex = state.requiredActions.length

      Vue.set(state.requiredActions, updateIndex >= 0 ? updateIndex : newIndex, action)
    }
  },
  actions: {
    getRequiredActions (serverModuleName = '', serverEntityName = '', entityKey = '') {
      return function ({ state, getters, commit, dispatch, rootGetters }, options = {}) {
        const o = base.getOptions(options, {
          language: rootGetters['gui/getLanguage'],
          page: REQUIRED_ACTIONS_INITIAL_VALUES.page,
          pageSize: REQUIRED_ACTIONS_INITIAL_VALUES.pageSize
        })

        commit('setLoading', { key: 'getRequiredActions', loading: true, initial: true })

        // Use searchnext for Orders, search for other entities
        const endpointModule = serverEntityName === 'Order'
          ? STOREMODULE_ENDPOINTMODULE_MAP.searchnext
          : STOREMODULE_ENDPOINTMODULE_MAP.search
        // Use 'Orders' (plural) for the controller name when using searchnext
        const entityName = serverEntityName === 'Order' ? 'Orders' : serverEntityName

        return new Promise(resolve => {
          http({
            method: 'post',
            url: `/${endpointModule}/api/${entityName}/RequiredActions`,
            data: o.data
          })
            .then(response => {
              commit('setRequiredActions', response.data.result)
              resolve(getters.getRequiredActions)
            })
            .finally(() => {
              commit('setLoading', { key: 'getRequiredActions', loading: false })
            })
        })
      }
    }
  }
}
